<template>
  <div class="topic">
    <div class="topic-wrapper">
      <div class="topic-left">
        <YorkbbsImage
          class="topic-logo"
          width="112px"
          height="48px"
          :src="require('@/assets/images/car/logo.png')"
          link="/"
          alt="约克汽车:多伦多汽车信息平台/多伦多二手车和转lease信息平台"
        ></YorkbbsImage>
        <ul class="topic-list">
          <li class="topic-item">
            <router-link class="topic-item__link" to="/">
              <img class="topic-item__icon" :src="require('@/assets/images/car/icon_home.png')" />
              <div class="topic-item__name">首页</div>
            </router-link>
          </li>
          <li class="topic-item" :class="{ active: topicEnglishName === 'used' }">
            <router-link class="topic-item__link" to="/list/used">
              <img class="topic-item__icon" :src="require('@/assets/images/car/icon_used.png')" />
              <div class="topic-item__name">二手车</div>
            </router-link>
          </li>
          <li class="topic-item" :class="{ active: topicEnglishName === 'lease' }">
            <router-link class="topic-item__link" to="/list/lease">
              <img class="topic-item__icon" :src="require('@/assets/images/car/icon_lease.png')" />
              <div class="topic-item__name">转 lease</div>
            </router-link>
          </li>
          <li class="topic-item">
            <a class="topic-item__link" target="_blank" :href="`/list/dealer` | hostBuild('forum')">
              <img class="topic-item__icon" :src="require('@/assets/images/car/icon_shop.png')" />
              <div class="topic-item__name">车行专卖</div>
            </a>
          </li>
        </ul>
      </div>
      <div class="topic-center">
        <el-input
          class="topic-search__input"
          clearable
          placeholder="请输入品牌/车系，如 奥迪A8​"
          v-model="keyword"
          @keyup.enter.native="handleSearch"
        >
          <button class="topic-search__button" slot="append" @click="handleSearch">
            <i class="yk-search_forum"></i>
          </button>
        </el-input>
      </div>
      <div class="topic-right">
        <div class="topic-button__list">
          <el-dropdown class="topic-button__item" trigger="hover">
            <el-button type="danger">
              <i class="yk-house_write"></i>
              <span>卖车</span>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a target="_blank" href="/publish/used">二手车</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a target="_blank" href="/publish/lease">转 lease</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <a class="topic-button__item" target="_blank" :href="'/center/information' | hostBuild('home')">
            <el-button>
              <i class="yk-house_user"></i>
              <span>我的汽车</span>
            </el-button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Topic',
  props: { placeholder: String },
  data() {
    return {
      // 搜索关键词
      keyword: '',
    };
  },
  created() {
    const { keyword } = this.$route.query;
    if (keyword) {
      this.keyword = keyword;
    }
  },
  computed: {
    topicEnglishName() {
      return this.$route.path.split('/')[2];
    },
  },
  methods: {
    /**
     * 搜索
     */
    handleSearch() {
      const keyword = this.keyword.trim();
      if (!keyword) return this.$warning('请输入搜索关键词');

      if (this.$route.name === 'Search') {
        this.$router.push({ query: { ...this.$route.query, keyword } });
      } else {
        window.open(`/search?keyword=${keyword}&tab=${this.$route.name === 'ListUsed' ? 1 : 2}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.topic {
  padding-bottom: 20px;
  box-shadow: 0 4px 4px rgba($color: #000000, $alpha: 0.1);
  margin: 20px 0;
}
.topic-wrapper {
  width: 1170px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.topic-left {
  display: flex;
  align-items: center;
}
.topic-right {
  display: flex;
  align-items: center;
}
.topic-list {
  display: flex;
  margin-left: 50px;
}
.topic-item {
  text-align: center;
  margin-right: 35px;
  position: relative;
  &.active {
    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: -20px;
      height: 3px;
      background: var(--primary-color);
      z-index: 1;
    }
  }
}
.topic-item__link {
  display: block;
  color: #191919;
  &:hover {
    color: var(--primary-color);
  }
}
.topic-item__icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-bottom: 2px;
}
.topic-item__name {
  font-size: 14px;
  line-height: 20px;
  color: inherit;
  text-align: center;
}

.topic-search__input {
  width: 293px;
  ::v-deep {
    .el-input__inner {
      border-right: 0 none;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }
    .el-input-group__append {
      padding: 0;
      border: 0 none;
      i {
        color: #fff;
      }
    }
  }
  .topic-search__button {
    width: 52px;
    height: 40px;
    background-color: var(--primary-color);
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    &:hover {
      background: #e96161;
      border-color: #e96161;
      color: #fff;
    }
  }
}
.topic-button__list {
  display: flex;
}
.topic-button__item {
  display: block;
  &:not(:last-child) {
    margin-right: 20px;
  }
  ::v-deep {
    .el-button {
      font-size: 16px;
      i {
        margin-right: 6px;
      }
    }
  }
}

::v-deep {
  .el-dropdown-menu__item {
    width: 128px;
    box-sizing: border-box;
    a {
      display: block;
    }
  }
}
</style>
